import React from 'react';
import { Image } from '../../../commonTypes/image';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { ImageWrapper, StyledImage } from './styles';

export type TestimonialImageProps = {
  image: Image;
} & ComponentProps;

const TestimonialImage: React.FC<TestimonialImageProps> = ({ image, ...props }) => {
  return (
    <ImageWrapper {...componentProps(props)}>
      <StyledImage image={image} />
    </ImageWrapper>
  );
};

export default applyComponentTheme(TestimonialImage, 'TestimonialImage');
